<template>
  <div class="errors">
    <v-overlay :value="fetchErrorLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <v-card>
        <v-card-title>
          <v-row>
            <v-col align="start">
              <div>
                <span class="text-h6 my-2">Errors:</span>
                <span class="text-h6 my-2"
                  >&nbsp;{{ errors.length }} / {{ errorsCount }}</span
                >
              </div>
            </v-col>
            <v-col align="end">
              <v-btn class="ml-2 my-2" @click="fetchOrders">Load more</v-btn>
              <v-btn class="ml-2 my-2" @click="refresh" icon>
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-data-iterator :items="errors" :page="page" :search="search">
            <template v-slot:header>
              <v-toolbar dark color="red accent-2" class="mb-1">
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  color="red"
                  prepend-inner-icon="mdi-magnify"
                  label="Search"
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:default="props">
              <v-row>
                <v-col v-for="item in props.items" :key="item.path" cols="12">
                  <ErrorCard
                    :item="item"
                    v-on:seeDetails="seeDetails"
                    v-on:deleteOne="deleteOne"
                    v-on:openContent="openContent"
                    v-on:retryOne="retryOne"
                  />
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>Details</v-card-title>
        <v-card-text v-if="dialog">
          <v-text-field
            readonly
            outlined
            label="Error Path"
            :value="currentError.path"
          ></v-text-field>
          <v-text-field
            readonly
            outlined
            label="Original Path"
            :value="currentError.original_path"
          ></v-text-field>
          <v-text-field
            readonly
            outlined
            label="Original Topic"
            :value="currentError.original_topic"
          ></v-text-field>
          <v-text-field
            readonly
            outlined
            label="Source Path"
            :value="currentError.source_path"
          ></v-text-field>
          <v-text-field
            readonly
            outlined
            label="Source Topic"
            :value="currentError.source_topic"
          ></v-text-field>
          <v-text-field
            readonly
            outlined
            label="Additional fields"
            :value="currentError.additional_fields"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="contentDialog">
      <v-card>
        <v-card-title>Details</v-card-title>
        <v-card-text>
          <vue-json-pretty
            :path="'res'"
            :data="currentContent"
          ></vue-json-pretty>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import VueJsonPretty from "vue-json-pretty";
import ErrorCard from "@/components/Errors/ErrorCard";

export default {
  components: { VueJsonPretty, ErrorCard },
  data: () => {
    return {
      page: 1,
      search: "",
      currentError: null,
      dialog: false,
      contentDialog: false,
      currentContent: null,
      errors: [],
      nextPage: 1,
      pageSize: 50,
      errorsCount: 0,
    };
  },
  computed: {
    ...mapState({
      fetchErrorLoading: (state) => state.orders.fetchErrors.pending,
    }),
    computedErrors() {
      let errors = [];
      if (this.errors.errors) {
        this.errors.errors.forEach((error) => {
          error.content["path"] = error.path;
          errors.push(error.content);
        });
      }
      return errors;
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("orders", {
      fetchErrors: "fetchErrors",
      fetchErrorContent: "fetchErrorContent",
      deleteError: "deleteError",
      retryError: "retryError",
    }),
    fetchOrders() {
      this.fetchErrors({
        page: this.nextPage,
        pageSize: this.pageSize,
      })
        .then((data) => {
          let numberDiff = (this.nextPage - 1) * this.pageSize - data.number;
          if (numberDiff < 0) {
            this.nextPage += 1;
          }
          data.errors.forEach((error) => {
            error.content["path"] = error.path;
            this.errors.push(error.content);
          });
          this.errorsCount = data.number;
        })
        .catch((error) => {
          this.setError(error);
        });
    },
    seeDetails(error) {
      this.currentError = error;
      this.dialog = true;
    },
    openContent(path) {
      this.fetchErrorContent({ path: path })
        .then((data) => {
          this.currentContent = data;
          this.contentDialog = true;
        })
        .catch((error) => {
          this.setError(error);
        });
    },
    retryOne(path, topic_name, error_path) {
      this.retryError({
        path: path,
        topic_name: topic_name,
        error_path: error_path,
      })
        .then(() => {
          this.refresh();
        })
        .catch((error) => {
          this.setError(error);
        });
    },
    deleteOne(path) {
      this.deleteError({ path: path }).catch((error) => {
        this.setError(error);
      });
    },
    refresh() {
      this.errors = [];
      this.nextPage = 1;
      this.fetchOrders();
    },
  },
  created() {
    this.fetchOrders();
  },
};
</script>
